import React, {Component} from "react";
import NewsImage from "../../../images/home.jpg";

class ItemDashboard extends Component{

    constructor(props){
        super(props);
        this.state = {
            itemDashboard : 
                {
                    id : "1",
                    date : "6th  December, 2020",
                    time : "03:58AM",
                    name : "LocalTrade",
                    totalRaise : "$28,000",
                    content : "HIncubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only. All projects listed here are part of our incubation program and subjected to additional... HIncubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only. All projects listed here are part of our incubation program and subjected to additional...",
                },
                style : {
                    textAlign : "center",
                }
        }
    }

    render(){
        return(
            <div className="news-card sec-bg sec-bg-cont br-10 item-dashboard">
                <div className="news-card-content-breadcrumb">
                    <h2>{this.state.itemDashboard.name}</h2>
                    <div className="news-card-social">
                        <i className="fab fa-twitter"></i> 
                        <i className="fab fa-facebook"></i> 
                        <i className="fab fa-whatsapp"></i> 
                    </div>
                    <div>
                        <p className="sec-txt small-txt news-card-content">{this.state.itemDashboard.content}</p>
                    </div>
                    <p className="small-txt prim-txt">Read More <i className="fas fa-angle-down"></i></p>
                    <div className="rounds-widget">
                        <div className="rounds-card">
                            <div className="rounds-flex">
                                <h5 className="sec-txt">Private Round</h5>
                                <button>Sold Out</button>
                            </div>
                            <div>
                                <div className="progress-bar">
                                    <div></div>
                                </div>
                            </div>
                            <div className="rounds-flex">
                                <h5 className="sec-txt">100%</h5>
                                <h5>$90,000/$90,000 BUSD</h5>
                            </div>
                        </div>
                        <div className="rounds-card">
                            <div className="rounds-flex">
                                <h5 className="sec-txt">Public Round</h5>
                                <button>Sold Out</button>
                            </div>
                            <div>
                                <div className="progress-bar">
                                    <div></div>
                                </div>
                            </div>
                            <div className="rounds-flex">
                                <h5 className="sec-txt">100%</h5>
                                <h5>$90,000/$90,000 BUSD</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="news-card-img-c">
                    <h4 className="sec-txt">Your Tier</h4>
                    <div className="rounds-flex">
                        <p>at least Tier-1 required</p>
                        <button>Get a tier</button>
                    </div>
                    <h4 className="sec-txt">Your Balance</h4>
                    <div className="rounds-flex">
                        <p>0 BSUD</p>
                        <button>Buy BUSD</button>
                    </div>
                    <div className="rounds-flex">
                        <p className="sec-txt small-txt">Allocation</p>
                        <p className="sec-txt small-txt">Private: 0 BUSD</p>
                        <p className="sec-txt small-txt">Public: 0 BUSD</p>
                    </div>
                    <div className="rounds-flex">
                        <p className="sec-txt small-txt">Swapped</p>
                        <p className="sec-txt small-txt">Private: 0 BUSD</p>
                        <p className="sec-txt small-txt">Public: 0 BUSD</p>
                    </div>
                    <div className="rounds-flex">
                        <p className="sec-txt small-txt">Owed</p>
                        <p className="sec-txt small-txt">0 LOTT</p>
                    </div>
                    <div className="rounds-flex">
                        <div>CLAIM IN</div>
                        <div>
                            <p style={this.state.style}>00</p>
                            <p className="small-txt sec-txt" style={this.state.style}>Days</p>
                        </div>:
                        <div>
                            <p style={this.state.style}>00</p>
                            <p className="small-txt sec-txt" style={this.state.style}>Hrs</p>
                        </div>:
                        <div>
                            <p style={this.state.style}>00</p>
                            <p className="small-txt sec-txt" style={this.state.style}>Min</p>
                        </div>:
                        <div>
                            <p style={this.state.style}>00</p>
                            <p className="small-txt sec-txt" style={this.state.style}>Sec</p>
                        </div>
                    </div>
                    <div>
                        <button>Claim 0 LOTT</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ItemDashboard;